export default __webpack_public_path__ + "static/media/a023-startup3-short.1bc00da5.png";